import React from "react"

const BoxGroup = ({ children, className }) => {
  return <div className={`${className || ""}`}>{children}</div>
}

export default BoxGroup
